import { Country, NS3451, OMUK } from '@consigli/types';

import { TreeNode } from '@/pages/insight/folders/util/document-list-to-tree';

export function getStructure(country: Country): Record<string, TreeNode> {
  const structure: Record<string, TreeNode> = {};

  let standardEnum: typeof NS3451 | typeof OMUK;
  let uncategorizedKey: string;

  if (country === Country.NORWAY) {
    standardEnum = NS3451;
    uncategorizedKey = NS3451.UNCATEGORIZED;
  } else {
    // Use OMUK as the default standard for UK and all other countries
    standardEnum = OMUK;
    uncategorizedKey = OMUK.UNCATEGORIZED;
  }

  for (const key in standardEnum) {
    if (key !== uncategorizedKey) {
      const enumKey = key as keyof typeof standardEnum;
      const parts = standardEnum[enumKey].split('_');

      let level: number;
      if (country === Country.NORWAY) {
        // For NS3451, level is determined by the length of the numeric part after NS3451_
        // NS3451_1 -> level 1, NS3451_11 -> level 2, NS3451_111 -> level 3
        const numericPart = parts[1]; // The part after NS3451_
        level = numericPart.length;
      } else {
        // For OMUK and future standards, level is based on number of underscore-separated parts
        level = parts.length - 1;
      }

      structure[standardEnum[enumKey]] = {
        id: standardEnum[enumKey],
        children: new Map(),
        level,
      };
    }
  }

  // manually add uncategorized at the end
  structure[uncategorizedKey] = {
    id: uncategorizedKey,
    level: 1,
    children: new Map(),
  };

  return structure;
}
